/**
 * Category metadata for tool grouping in the sidebar browser.
 *
 * Shared between ToolsTab and any future category-based views.
 */

import {
CheckCircle, Eye, FileText, Lock, Package,
  Repeat, Sparkles, Wrench, Zap, } from 'lucide-react';
import React from 'react';

import type { ITool } from '@/interfaces/ITool';

export interface CategoryMeta {
  label: string;
  icon: React.ReactNode;
  directories: string[];
}

export const CATEGORY_MAP: CategoryMeta[] = [
  { label: 'Converters', icon: <Repeat className="h-3.5 w-3.5" />, directories: ['Converters'] },
  { label: 'Formatters & Minifiers', icon: <Sparkles className="h-3.5 w-3.5" />, directories: ['Formatters & Minifiers'] },
  { label: 'Encoders & Decoders', icon: <Lock className="h-3.5 w-3.5" />, directories: ['Encoders & Decoders'] },
  { label: 'Generators', icon: <Zap className="h-3.5 w-3.5" />, directories: ['Generators'] },
  { label: 'Text Tools', icon: <FileText className="h-3.5 w-3.5" />, directories: ['Text Tools'] },
  { label: 'Validators & Testers', icon: <CheckCircle className="h-3.5 w-3.5" />, directories: ['Validators & Testers'] },
  { label: 'Visualizers', icon: <Eye className="h-3.5 w-3.5" />, directories: ['Visualizers'] },
  { label: 'Utilities', icon: <Wrench className="h-3.5 w-3.5" />, directories: ['Utilities'] },
];

export function resolveCategory(tool: ITool): CategoryMeta {
  if (tool.type === 'visualizer') {
    return CATEGORY_MAP.find((m) => m.label === 'Visualizers')!;
  }
  const cat = (tool.category ?? '').toLowerCase();
  for (const meta of CATEGORY_MAP) {
    if (meta.directories.some((dir) => cat === dir.toLowerCase())) return meta;
  }
  return { label: tool.category ?? 'Other', icon: <Package className="h-3.5 w-3.5" />, directories: [] };
}
